import * as types from "./types";

export const setWalletBalance = (wallet_balance) => ({
    type: types.MONEYBLOX_WALLET_BALANCE,
    wallet_balance: wallet_balance
});

export const setWalletUserSessionDetails = (data) => ({
    type: types.MONEYBLOX_WALLET_USER_DETAILS,
    user_details: data
});

export const showMoneyBloxModal = () => ({
    type: types.MONEYBLOX_WALLET_MODAL_SHOW,
    isVisible: true
});

export const hideMoneyBloxModal = (data) => ({
    type: types.MONEYBLOX_WALLET_MODAL_HIDE,
    isVisible: false
});